var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"show",rawName:"v-show",value:(_vm.url.x2),expression:"url.x2"}],attrs:{"src":_vm.url.x2,"srcset":_vm.url.x3 && (_vm.url.x3 + ' 3x')}})}
var staticRenderFns = []

export { render, staticRenderFns }